<template>
  <div class="v-inner v-inner-content" :class="bgColor">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <slot>
          <router-view :key="$route.name" />
        </slot>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: "InnerContent",
  props: {
    bgColor: {
      type: String,
      default: "bhWhite"
    }
  },
  data: () => ({})
};
</script>

<style lang="scss">
.v-inner-content {
  flex: 1 !important;
  max-width: calc(100% - 264px); // 264px = inner drawer
}
</style>
